import { TextField as MuiTextField, type TextFieldProps as MuiTextFieldProps } from '@mui/material';

export type TextFieldProps = MuiTextFieldProps;

export const TextField = (props: Readonly<TextFieldProps>) => <MuiTextField {...props} />;
